export function overwriteQueryParam(queryString, k, v) {
  const searchParams = new URLSearchParams(queryString);
  searchParams.set(k, v);
  return searchParams.toString();
}



// WEBPACK FOOTER //
// ./src/utils/urlUtils.js